import React, { useEffect, useState, useMemo, useRef } from "react";
import styled from "styled-components";
import {
  Badge,
  Col,
  Row,
  Avatar,
  Tooltip,
  Form,
  message,
  Spin,
  Upload,
  Modal,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import ImportIcon from "../../assets/images/download1.svg";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import NexusFuelDetailsAI from "./nexusFuelDetailsAI";
import { fetchNexusAssets } from "./nexusTrakingApi";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";

export const WrapperBox = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }
  @media (max-width: 320px) {
    .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    }
    .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }
  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .badg {
    padding: 6px;
  }
  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
`;

const DB_BASE = "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/";

const dbHeaders = () => {
  const raw = window?.localStorage?.getItem("token") || "";
  const token = raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`;
  return { "Content-Type": "application/json", Authorization: token };
};

const createNexusFuelEntry = (payload) =>
  fetch(`${DB_BASE}nexus/createfuelentry`, {
    method: "POST",
    headers: dbHeaders(),
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .catch((err) => {
      console.error("[createNexusFuelEntry] error:", err);
      return null;
    });

const getAllNexusFuelEntry = (params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== "",
    ),
  );
  const qs = new URLSearchParams(cleanParams).toString();
  return fetch(`${DB_BASE}nexus/getallfuelentry${qs ? `?${qs}` : ""}`, {
    method: "GET",
    headers: dbHeaders(),
  })
    .then((r) => r.json())
    .catch((err) => {
      console.error("[getAllNexusFuelEntry] error:", err);
      return null;
    });
};

const updateNexusFuelEntry = (payload) =>
  fetch(`${DB_BASE}nexus/updatefuelentry`, {
    method: "PUT",
    headers: dbHeaders(),
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .catch((err) => {
      console.error("[updateNexusFuelEntry] error:", err);
      return null;
    });

const deleteNexusFuelEntry = (id) =>
  fetch(`${DB_BASE}nexus/deletefuelentry?id=${id}`, {
    method: "DELETE",
    headers: dbHeaders(),
  })
    .then((r) => r.json())
    .catch((err) => {
      console.error("[deleteNexusFuelEntry] error:", err);
      return null;
    });

// ─── Import file reading ────────────────────────────────────────────────
// Columns (header names are matched ignoring case and spacing), same as the
// sample file: Vehicle Reg No, Fuel Date, Qty, Rate, ODO, Station Name, Transporter
const IMPORT_COLUMNS = {
  vehicle: ["vehicleregno", "vehicle", "vehicleno", "regno"],
  date: ["fueldate", "date"],
  qty: ["qty", "litresfueled", "litres", "quantity"],
  rate: ["rate", "priceperlitre", "price"],
  odo: ["odo", "odoreading"],
  station: ["stationname", "station"],
  transporter: ["transporter"],
};

const normKey = (k) => String(k || "").toLowerCase().replace(/[^a-z0-9]/g, "");

const pickColumn = (row, names) => {
  const key = Object.keys(row).find((k) => names.includes(normKey(k)));
  return key === undefined ? undefined : row[key];
};

// DD/MM/YYYY, YYYY-MM-DD, an Excel serial number or a Date
const parseFuelDate = (value) => {
  if (value === undefined || value === null || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === "number") {
    const parsed = XLSX.SSF.parse_date_code(value);
    return parsed ? new Date(parsed.y, parsed.m - 1, parsed.d) : null;
  }
  const text = String(value).trim();
  let m = text.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  m = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const fallback = new Date(text);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

const SAMPLE_ROWS = [
  { "Vehicle Reg No": "KA1234532", "Fuel Date": "07/01/2026", Qty: "40.00", Rate: "180.00", ODO: "160", "Station Name": "TQS Agency", Transporter: "ABC Transport" },
  { "Vehicle Reg No": "KA1234532", "Fuel Date": "08/01/2026", Qty: "35.50", Rate: "182.00", ODO: "420", "Station Name": "TQS Agency", Transporter: "ABC Transport" },
];

const FUEL_TYPE_OPTIONS = [
  { value: "Diesel", label: "Diesel" },
  { value: "Petrol", label: "Petrol" },
  { value: "CNG", label: "CNG" },
  { value: "Electric", label: "Electric" },
];

const NexusFuelAI = () => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );

  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("NE_FUEL", "CRF"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("NE_FUEL", "UPF"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("NE_FUEL", "DEF"),
    [reduxPermissions],
  );

  const [form] = Form.useForm();
  const [filterform] = Form.useForm();

  const [vehicleOptionss, setVehicleOptions] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(false);

  // The account's own vehicles. The backend scopes this to the account's TraKing
  // company; only the operator account (59) passes none and gets them all.
  const fetchAssetsByCompany = async (companyId) => {
    setVehicleLoading(true);
    try {
      const data = await fetchNexusAssets(companyId);
      setVehicleOptions(
        Array.isArray(data?.response)
          ? data.response.map((a) => ({
              value: a.asset_id,
              label: a.asset_name,
            }))
          : [],
      );
    } catch (error) {
      console.error("[fetchAssetsByCompany] error:", error);
      setVehicleOptions([]);
    } finally {
      setVehicleLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetsByCompany(userInfo?.NexusCompId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.NexusCompId]);

  // Name saved on the entry being edited: shown (and kept) even if the vehicle list
  // does not include that vehicle, so the field never falls back to the raw id
  const [savedVehicle, setSavedVehicle] = useState(null);
  const vehicleSelectOptions = useMemo(() => {
    if (
      savedVehicle?.value != null &&
      !vehicleOptionss.some((v) => String(v.value) === String(savedVehicle.value))
    ) {
      return [savedVehicle, ...vehicleOptionss];
    }
    return vehicleOptionss;
  }, [vehicleOptionss, savedVehicle]);

  const [loading, setLoading] = useState(false);
  const [fuelData, setFuelData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [filterData, setFilterData] = useState({
    vehicle: undefined,
    daterange: undefined,
    search: "",
  });
  const [filterCount, setFilterCount] = useState(0);

  // ─── Export / import ────────────────────────────────────────────────
  const exportAllowed = useMemo(() => hasPermission("NE_FUEL", "FEX"), [reduxPermissions]);
  const importAllowed = useMemo(() => hasPermission("NE_FUEL", "FIM"), [reduxPermissions]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef(null);
  const [importOpen, setImportOpen] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importErrors, setImportErrors] = useState([]);

  const listParams = (page, size) => ({
    page,
    pageSize: size,
    vehId: filterData?.vehicle,
    search: filterData?.search,
    dateFrom: filterData?.daterange?.[0] ? dayjs(filterData.daterange[0]).format("YYYY-MM-DD") : undefined,
    dateTo: filterData?.daterange?.[1] ? dayjs(filterData.daterange[1]).format("YYYY-MM-DD") : undefined,
  });

  // exports every entry matching the current filters, not just this page
  const handleExport = async () => {
    setCSVLoader(true);
    try {
      const res = await getAllNexusFuelEntry(listParams(1, Math.max(total, 1)));
      const rows = res?.data?.data || [];
      if (!rows.length) {
        message.error("No data available to download.");
        return;
      }
      setCSVList(
        rows.map((r) => ({
          Vehicle: r.VehRegNo || "-",
          "Fuel Date": r.FuelDate ? dayjs(r.FuelDate).format("DD/MM/YYYY") : "-",
          "Litres Fueled": r.LitresFueled ?? "-",
          "Price Per Litre": r.PricePerLitre ?? "-",
          Amount: r.Amount != null ? Number(r.Amount).toFixed(2) : "-",
          "ODO Reading": r.OdoReading ?? "-",
          Mileage: r.Mileage ?? "-",
          "Station Name": r.StationName || "-",
          Transporter: r.TransporterName || "-",
          "Created By": r.CreatedByName || "-",
        })),
      );
      setTimeout(() => csvLinkEl.current?.link?.click(), 300);
    } catch (error) {
      console.error("[handleExport] error:", error);
      message.error("Unable to export the fuel entries.");
    } finally {
      setCSVLoader(false);
    }
  };

  const handleDownloadSample = () => {
    const csv = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(SAMPLE_ROWS));
    saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "FuelDataSample.csv");
  };

  const handleImportFile = async (file) => {
    setImporting(true);
    setImportErrors([]);
    try {
      const workbook = XLSX.read(await file.arrayBuffer(), { type: "array", cellDates: true });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: true });
      if (!sheetRows.length) {
        message.error("The file has no rows.");
        return false;
      }

      const rows = [];
      const problems = [];
      sheetRows.forEach((row, idx) => {
        const rowNo = idx + 2; // header is row 1
        const regNo = String(pickColumn(row, IMPORT_COLUMNS.vehicle) ?? "").trim();
        const vehicle = vehicleOptionss.find(
          (v) => String(v.label).trim().toLowerCase() === regNo.toLowerCase(),
        );
        const fuelDate = parseFuelDate(pickColumn(row, IMPORT_COLUMNS.date));
        const transporterName = String(pickColumn(row, IMPORT_COLUMNS.transporter) ?? "").trim();
        const transporter = transporterName
          ? (transporterList || []).find(
              (t) => String(t.Name).trim().toLowerCase() === transporterName.toLowerCase(),
            )
          : null;
        if (!regNo && fuelDate == null && pickColumn(row, IMPORT_COLUMNS.qty) === "") return; // blank line
        if (!vehicle) {
          problems.push(`Row ${rowNo}: vehicle "${regNo}" was not found in your fleet.`);
          return;
        }
        rows.push({
          RowNo: rowNo,
          VehId: vehicle.value,
          VehRegNo: vehicle.label,
          FuelDate: fuelDate ? dayjs(fuelDate).format("YYYY-MM-DDTHH:mm:ss") : null,
          LitresFueled: pickColumn(row, IMPORT_COLUMNS.qty),
          PricePerLitre: pickColumn(row, IMPORT_COLUMNS.rate),
          OdoReading: pickColumn(row, IMPORT_COLUMNS.odo),
          StationName: String(pickColumn(row, IMPORT_COLUMNS.station) ?? "").trim(),
          TransporterId: transporter?.ID ?? null,
          TransporterName: transporter?.Name || transporterName || null,
        });
      });

      let successCount = 0;
      let serverErrors = [];
      if (rows.length) {
        const response = await fetch(`${DB_BASE}nexus/importfuelentries`, {
          method: "POST",
          headers: dbHeaders(),
          body: JSON.stringify({ rows }),
        });
        const body = await response.json().catch(() => null);
        if (!response.ok) {
          serverErrors = [body?.data || body?.message || "The import failed."];
        } else {
          successCount = body?.data?.successCount || 0;
          serverErrors = body?.data?.errors || [];
        }
      }

      const allErrors = [...problems, ...serverErrors];
      if (successCount > 0) {
        message.success(`${successCount} fuel ${successCount === 1 ? "entry" : "entries"} imported.`);
        fetchFuelEntryData();
      }
      if (allErrors.length) {
        setImportErrors(allErrors);
      } else if (successCount > 0) {
        setImportOpen(false);
      }
    } catch (error) {
      console.error("[handleImportFile] error:", error);
      message.error("Something went wrong while reading the file.");
    } finally {
      setImporting(false);
    }
    return false; // never let antd upload it itself
  };

  const fetchFuelEntryData = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        pageSize,
        vehId: filterData?.vehicle,
        search: filterData?.search,
        dateFrom: filterData?.daterange?.[0]
          ? dayjs(filterData.daterange[0]).format("YYYY-MM-DD")
          : undefined,
        dateTo: filterData?.daterange?.[1]
          ? dayjs(filterData.daterange[1]).format("YYYY-MM-DD")
          : undefined,
      };
      const res = await getAllNexusFuelEntry(params);
      setFuelData(res?.data?.data || []);
      setTotal(res?.data?.total || 0);
    } catch (error) {
      console.error("[fetchFuelEntryData] error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFuelEntryData();
    const count = Object.values(filterData).filter(
      (val) => val && val.length !== 0,
    ).length;
    setFilterCount(count);
  }, [currentPage, pageSize, filterData]);

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const [hoveredrow, setHoveredrow] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const emptyFormData = {
    Id: "",
    vehicle: undefined,
    fueldate: "",
    litres: "",
    price: "",
    odoreading: "",
    stationName: "",
    transporter: undefined,
    fuelType: undefined,
    aiFuelType: "",
  };
  const [formData, setFormData] = useState(emptyFormData);

  const loadingText = ["", ".", "..", "..."];
  const [dotIndex, setDotIndex] = useState(0);
  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setDotIndex((i) => (i + 1) % loadingText.length);
    }, 500);
    return () => clearInterval(interval);
  }, [loading]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSelectChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [value]: field }));
  };

  const handleFilterChange = (e) => {
    const { value, name } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  const handleFilterSelectChange = (field, value) => {
    setFilterData((prev) => ({ ...prev, [value]: field }));
  };

  const handleCreateClick = () => {
    setIsEditing(false);
    setFormData(emptyFormData);
    form.resetFields();
    setDrawerOpen(true);
  };

  const openEdit = (record) => {
    setSavedVehicle(
      record?.VehId != null
        ? { value: record.VehId, label: record.VehRegNo || String(record.VehId) }
        : null,
    );
    setIsEditing(true);
    setFormData({
      Id: record?.Id,
      vehicle: record?.VehId,
      fueldate: record?.FuelDate ? dayjs(record.FuelDate) : "",
      litres: record?.LitresFueled,
      price: record?.PricePerLitre,
      odoreading: record?.OdoReading,
      stationName: record?.StationName,
      transporter: record?.TransporterId,
      fuelType: record?.FuelType,
      aiFuelType: record?.AIFuelType,
    });
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setSavedVehicle(null);
    setIsEditing(false);
    setDrawerOpen(false);
    setFormData(emptyFormData);
  };

  const buildPayload = () => {
    const selectedVehicle = vehicleSelectOptions.find(
      (v) => String(v.value) === String(formData.vehicle),
    );
    const selectedTransporter = transporterList?.find(
      (t) => t.ID === formData.transporter,
    );
    return {
      VehId: formData.vehicle,
      VehRegNo: selectedVehicle?.label || "",
      FuelDate: formData.fueldate
        ? dayjs(formData.fueldate).format("YYYY-MM-DDTHH:mm:ss")
        : null,
      LitresFueled: Number(formData.litres),
      PricePerLitre: Number(formData.price),
      OdoReading: Number(formData.odoreading),
      StationName: formData.stationName || "",
      TransporterId: formData.transporter || null,
      TransporterName: selectedTransporter?.Name || null,
      FuelType: formData.fuelType || null,
      AIFuelType: formData.aiFuelType || null,
    };
  };

  const handleSubmitForm = async () => {
    try {
      setLoading(true);
      const payload = buildPayload();
      const res = isEditing
        ? await updateNexusFuelEntry({ Id: formData.Id, ...payload })
        : await createNexusFuelEntry(payload);

      if (res?.ResponseCode === 200) {
        message.success(
          isEditing
            ? "Fuel entry updated successfully"
            : "Fuel entry created successfully",
        );
        handleCancel();
        fetchFuelEntryData();
      } else {
        message.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("[handleSubmitForm] error:", error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleClickDelete = (id) => {
    setDeleteId(id);
    setIsDeleteModalVisible(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await deleteNexusFuelEntry(deleteId);
      if (res?.ResponseCode === 200) {
        message.success("Fuel entry deleted successfully");
        setDetailsOpen(false);
        fetchFuelEntryData();
      } else {
        message.error(res?.message || "Delete failed");
      }
    } catch (error) {
      console.error("[handleDelete] error:", error);
      message.error("Delete failed");
    } finally {
      setLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  const columns = [
    {
      title: "Vehicle",
      dataIndex: "VehRegNo",
      key: "VehRegNo",
    },
    {
      title: "Fuel Date",
      dataIndex: "FuelDate",
      key: "FuelDate",
      render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "Litres Fueled",
      dataIndex: "LitresFueled",
      key: "LitresFueled",
    },
    {
      title: "Price Per Litre",
      dataIndex: "PricePerLitre",
      key: "PricePerLitre",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      render: (value) => {
        if (value == null || isNaN(value)) return "-";
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      },
    },
    {
      title: "ODO Reading",
      dataIndex: "OdoReading",
      key: "OdoReading",
    },
    {
      title: "Mileage",
      dataIndex: "Mileage",
      key: "Mileage",
      render: (value) => value ?? "-",
    },
    {
      title: "Created by",
      dataIndex: "CreatedByName",
      key: "CreatedByName",
    },
    {
      title: "Transporter",
      dataIndex: "TransporterName",
      key: "TransporterName",
      render: (text) => text || "-",
    },
    {
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <div
          className={
            hoveredrow === record?.Id ? "d-flex gap-3 opacity-100" : "opacity-0"
          }
        >
          <Tooltip title={!updateAllowed ? "No permission" : ""}>
            <EditIcon
              style={{ cursor: updateAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!updateAllowed) return;
                e.stopPropagation();
                openEdit(record);
              }}
            />
          </Tooltip>
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <DeleteIcon
              style={{
                cursor: deleteAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                handleClickDelete(record?.Id);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const AddEditFormm = useMemo(() => {
    return {
      pages: [
        {
          colSpan: [
            [6, 6, 6, 6],
            [6, 6, 6, 6],
            [6, 6],
          ],
          fields: [
            [
              {
                id: 1,
                label: "Vehicle",
                type: "selectwithvalue",
                name: "vehicle",
                options: vehicleSelectOptions,
                loading: vehicleLoading,
                validationRules: [
                  { required: true, message: "Vehicle is required" },
                ],
              },
              {
                id: 2,
                label: "Fuel Date",
                type: "date",
                showtime: true,
                format: "YYYY-MM-DD HH:mm:ss",
                name: "fueldate",
                placeholder: "Select date",
                validationRules: [
                  { required: true, message: "Fuel Date is required" },
                ],
              },
              {
                id: 3,
                label: "Litres Fueled",
                type: "text",
                name: "litres",
                validationRules: [
                  { required: true, message: "Litres Fueled is required" },
                ],
              },
              {
                id: 4,
                label: "Price per Litre",
                type: "text",
                name: "price",
                validationRules: [
                  { required: true, message: "Price per Litre is required" },
                ],
              },
            ],
            [
              {
                id: 5,
                label: "ODO Reading",
                type: "text",
                name: "odoreading",
                validationRules: [
                  { required: true, message: "ODO Reading is required" },
                ],
              },
              {
                id: 6,
                label: "Station Name",
                type: "text",
                name: "stationName",
              },
              {
                id: 7,
                label: "Transporter",
                type: "selectwithvalue",
                name: "transporter",
                options: transporterList?.map((item) => ({
                  value: item?.ID,
                  label: item?.Name,
                })),
                validationRules: [],
              },
              {},
            ],
            [
              {
                id: 8,
                label: "Fuel Type",
                type: "selectwithvalue",
                name: "fuelType",
                options: FUEL_TYPE_OPTIONS,
              },
              {
                id: 9,
                label: "AI Fuel Type",
                type: "text",
                name: "aiFuelType",
              },
            ],
          ],
        },
      ],
    };
  }, [vehicleSelectOptions, vehicleLoading, transporterList]);

  const [showFilterModal, setShowFilterModal] = useState(false);

  const FilterForm = useMemo(() => {
    return {
      pages: [
        {
          colSpan: [[6, 6, 6]],
          fields: [
            [
              {
                id: 1,
                label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
                type: "selectwithvalue",
                name: "vehicle",
                options: vehicleOptionss,
                loading: vehicleLoading,
              },
              {
                id: 2,
                label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
                type: "daterange",
                name: "daterange",
                placeholder: ["Start Date", "End Date"],
              },
              {
                id: 3,
                label: <span style={{ color: "#5F6D8C" }}>Search</span>,
                type: "text",
                name: "search",
                placeholder: "Station, Transporter...",
              },
            ],
          ],
        },
      ],
    };
  }, [vehicleOptionss, vehicleLoading]);

  const clearFilters = () => {
    filterform.resetFields();
    setFilterData({ vehicle: undefined, daterange: undefined, search: "" });
  };

  return (
    <>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled onClick={handleDelete}>Yes</ButtonFilled>
            <Buttontransparent onClick={() => setIsDeleteModalVisible(false)}>
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      <UIModal
        width={900}
        open={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">
                    Filters({filterCount || 0})
                  </span>
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "15px" }}
          >
            <ButtonFilled onClick={clearFilters}>Clear All</ButtonFilled>
            <Buttontransparent onClick={() => setShowFilterModal(false)}>
              Cancel
            </Buttontransparent>
          </div>
        }
      >
        <WrapperBox>
          <GridBuilder
            formStructureJson={FilterForm}
            handleChange={handleFilterChange}
            formSubmit={() => setShowFilterModal(false)}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
          />
        </WrapperBox>
      </UIModal>

      {detailsOpen ? (
        <NexusFuelDetailsAI
          setDetailsOpen={setDetailsOpen}
          record={selectedRecord}
          updateAllowed={updateAllowed}
          deleteAllowed={deleteAllowed}
          onEdit={(record) => {
            setDetailsOpen(false);
            openEdit(record);
          }}
          onDelete={(id) => handleClickDelete(id)}
        />
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  <p>{total} Fuel Entry</p>
                  <div className="consingment_container_two" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                    <Tooltip title={!exportAllowed ? "No permission" : "Export"} placement="bottom">
                      <Spin spinning={CSVLoader}>
                        <img
                          src={ExportIcon}
                          alt="Export"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                            marginRight: "20px",
                            backgroundColor: "#EBF7ED",
                            borderRadius: "6px",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleExport();
                          }}
                        />
                      </Spin>
                    </Tooltip>
                    <CSVLink data={CSVList} filename={"NexusFuelEntry.csv"} ref={csvLinkEl} />
                    <Tooltip title={!importAllowed ? "No permission" : "Import"} placement="bottom">
                      <img
                        src={ImportIcon}
                        alt="Import"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: importAllowed ? "pointer" : "not-allowed",
                          marginRight: "20px",
                          backgroundColor: "#EBF7ED",
                          borderRadius: "6px",
                        }}
                        onClick={() => {
                          if (!importAllowed) return;
                          setImportErrors([]);
                          setImportOpen(true);
                        }}
                      />
                    </Tooltip>
                    <Badge
                      count={filterCount}
                      className="badg"
                      style={{ marginRight: "20px" }}
                    >
                      <Avatar
                        shape="circle"
                        size="small"
                        src={FilterIcon}
                        className="filterstyle"
                        onClick={() => setShowFilterModal(true)}
                        style={{ marginRight: "20px", cursor: "pointer" }}
                      />
                    </Badge>
                    <Tooltip title={!createAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        onClick={() => {
                          if (!createAllowed) return;
                          handleCreateClick();
                        }}
                        style={{
                          cursor: createAllowed ? "pointer" : "not-allowed",
                        }}
                        className="Create_btn"
                      >
                        + Create
                      </ButtonFilled>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div>
                <Spin spinning={loading}>
                  {fuelData.length > 0 && (
                    <StyledTable
                      pagination={false}
                      dataSource={fuelData}
                      columns={columns}
                      onRow={(record) => ({
                        onMouseEnter: () => setHoveredrow(record?.Id),
                        onMouseLeave: () => setHoveredrow(null),
                        onClick: () => {
                          setSelectedRecord(record);
                          setDetailsOpen(true);
                        },
                      })}
                    />
                  )}
                  <ReusablePagination
                    pageSize={pageSize}
                    handlePageSizeChange={handlePageSizeChange}
                    currentPage={currentPage}
                    total={total}
                    handlePageChange={handlePageChange}
                  />
                </Spin>
              </div>
            </Col>
          </Row>
        </>
      )}

      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={handleCancel}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              key="create"
              type="primary"
              loading={loading}
              disabled={loading}
              onClick={() => form.submit()}
            >
              {loading
                ? `${isEditing ? "Updating" : "Creating"}${loadingText[dotIndex]}`
                : isEditing
                  ? "Update"
                  : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>{isEditing ? "Modifying Fuel Entry" : "Creating Fuel Entry"}</p>
                <span>
                  <CloseOutlined onClick={() => setDrawerOpen(false)} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                handleSelectChange={handleSelectChange}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>

      <Modal
        title="Import Fuel Entries"
        open={importOpen}
        onCancel={() => setImportOpen(false)}
        footer={[
          <Buttontransparent key="sample" onClick={handleDownloadSample}>
            Sample file download
          </Buttontransparent>,
          <ButtonFilled key="close" onClick={() => setImportOpen(false)}>
            Close
          </ButtonFilled>,
        ]}
        width={640}
      >
        <Spin spinning={importing}>
          <Upload.Dragger beforeUpload={handleImportFile} showUploadList={false} accept=".csv,.xlsx,.xls" multiple={false}>
            <p style={{ margin: "12px 0" }}>Drop a CSV or Excel file here, or click to select one</p>
            <p style={{ color: "#5f6d8c", fontSize: 13 }}>
              Columns: Vehicle Reg No, Fuel Date (DD/MM/YYYY), Qty, Rate, ODO, Station Name, Transporter
            </p>
          </Upload.Dragger>
        </Spin>
        {importErrors.length > 0 && (
          <div style={{ marginTop: 16, maxHeight: 220, overflowY: "auto" }}>
            <strong style={{ color: "#d4380d" }}>
              {importErrors.length} {importErrors.length === 1 ? "row" : "rows"} could not be imported
            </strong>
            <ul style={{ paddingLeft: 18, margin: "8px 0 0" }}>
              {importErrors.map((err, i) => (
                <li key={i} style={{ fontSize: 13 }}>
                  {err}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </>
  );
};

export default NexusFuelAI;
